import { Drawer, Button, Form } from '@seiue/ui'
import { pickBy } from 'lodash'
import { EntryComponentsWrapper } from 'packages/theme'
import { AnyType } from 'packages/types'
import React, { useEffect } from 'react'
import styled from 'styled-components'

import { SearchFormItems } from './SearchFormItems'
import { FormConfig, ISearchParams } from './types'

/**
 *  筛选弹窗
 *
 * @param param - 参数
 * @param param.visible - 筛选抽屉是否可见
 * @param param.searchFormConfig - 筛选表单配置
 * @param param.searchParams - 已有筛选条件
 * @param param.title - 抽屉标题【可选】
 * @param param.footer - 抽屉页脚组件【可选】
 * @param param.onOk - 确认回调【可选】
 * @param param.onCancel - 取消回调【可选】
 * @returns React.ReactNode
 */
export const SearchModal: React.FC<{
  visible: boolean
  searchFormConfig: FormConfig
  searchParams: ISearchParams
  title?: string
  footer?: React.ReactNode
  onOk?: (values: AnyType) => void
  onCancel?: () => void
}> = ({
  visible,
  title,
  footer,
  searchFormConfig,
  searchParams,
  onOk,
  onCancel,
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ ...searchParams })
    } else {
      form.resetFields()
    }
  }, [visible])

  const onSubmit = () => {
    form
      .validateFields()
      .then((values: AnyType) => {
        const filterNotNullValues = pickBy({ ...values })
        onOk && onOk(filterNotNullValues)
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.error(err)
      })
  }

  const onClose = () => {
    onCancel && onCancel()
    form.resetFields()
  }

  return (
    <Drawer
      forceRender={true}
      visible={visible}
      title={title || '表格筛选'}
      onClose={onClose}
      headerStyle={{
        minHeight: '64px',
      }}
      footer={
        footer || [
          <Button
            key="1"
            onClick={onClose}
          >
            取消
          </Button>,
          <Button
            type="primary"
            key="2"
            onClick={onSubmit}
          >
            确定
          </Button>,
        ]
      }
      footerStyle={{
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <EntryComponentsWrapper>
        <StyledForm
          form={form}
          layout="vertical"
        >
          <SearchFormItems
            formConfig={searchFormConfig}
            onPressEnter={onSubmit}
            form={form}
          />
        </StyledForm>
      </EntryComponentsWrapper>
    </Drawer>
  )
}

const StyledForm = styled(Form)`
  .ant-form-item-label > label {
    color: ${(props) => props.theme.text._2};
    white-space: normal;
  }
  .ant-form-item {
    margin-bottom: 12px;
  }
`
